var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec12Img1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.41675C7.85417 2.41675 2.41667 7.85425 2.41667 14.5001C2.41667 21.1459 7.85417 26.5834 14.5 26.5834C21.1458 26.5834 26.5833 21.1459 26.5833 14.5001C26.5833 7.85425 21.1458 2.41675 14.5 2.41675ZM14.5 24.1667C9.17125 24.1667 4.83333 19.8288 4.83333 14.5001C4.83333 9.17133 9.17125 4.83341 14.5 4.83341C19.8287 4.83341 24.1667 9.17133 24.1667 14.5001C24.1667 19.8288 19.8287 24.1667 14.5 24.1667ZM20.0462 9.15925L12.0833 17.1222L8.95375 14.0047L7.25 15.7084L12.0833 20.5417L21.75 10.8751L20.0462 9.15925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec12Img1);
export default __webpack_public_path__ + "static/media/sec12img1.109bee2a71bf566a1f3c5c2fb18e05ab.svg";
export { ForwardRef as ReactComponent };